'use client';

import { c as _c } from "react/compiler-runtime";
import { twitter, chartPage, telegram, website, pageTitle, footerLink, footerExt } from '../constants';
import type { IconProps } from "@iconify/react";
import React from "react";
import { Divider, Image, Link, LinkIcon } from "@heroui/react";
import { Icon } from "@iconify/react";
import ChewySwapText from '@/components/Image/Svg/ChewySwapText';
import ChewyLogoFull from './Image/Svg/ChewyLogoFull';
import { RssIcon } from 'lucide-react';
type SocialIconProps = Omit<IconProps, "icon">;
export const footerNavigation = {
  services: [{
    name: "ChewySwap",
    href: "https://chewyswap.dog"
  }, {
    name: "DEX Aggregator",
    href: "../../../swap"
  }, {
    name: "Farms & Pools",
    href: "../../../farms"
  }, {
    name: "NFT Staking",
    href: "../../../nft-staking"
  }, {
    name: "Build",
    href: "../../../build"
  }, {
    name: "Stake Shiboshis",
    href: "../../../nft-staking/shiboshis-for-chewy"
  }],
  supportOptions: [{
    name: "Chewy Docs",
    href: "https://docs.chewyswap.com"
  }, {
    name: "Support Chat",
    href: telegram
  }, {
    name: "Shibarium NFT Bridge",
    href: "https://shibarium.shib.io/bridge-nfts"
  }, {
    name: "Shibarium Token Bridge",
    href: "https://shibarium.shib.io/bridge-tokens"
  }, {
    name: "Rescue Funds from Dead Protocols",
    href: "../../../rescue"
  }],
  aboutUs: [{
    name: "Audits",
    href: "https://docs.chewyswap.com/chewyswap-intro/audits"
  }, {
    name: "Assure KYC",
    href: "https://assuredefi.com/projects/chewyswap/"
  }, {
    name: "Latest News",
    href: "../../../news/"
  }, {
    name: "Submit NFT Collection",
    href: "https://www.jotform.com/form/251354609567060"
  }, {
    name: "Collaborations",
    href: "https://t.me/+RaLrVvDOLE1hZWY0"
  }],
  partners: [{
    name: "Chewy Protocol TVL",
    href: "https://defillama.com/protocol/chewyswap"
  }, {
    name: "Deploy Tokens on Bondle",
    href: "https://bondle.xyz/"
  }, {
    name: "Shibarium NFT Market",
    href: "https://app.chewyswap.dog/marketplace"
  }, {
    name: "K9 Liquid Staking",
    href: "https://www.k9finance.com/"
  }, {
    name: "DeBank CHEWY Page",
    href: "https://debank.com/official/ChewySwap"
  }],
  social: [{
    name: "Telegram",
    href: telegram,
    icon: (props: SocialIconProps) => <Icon {...props} icon="fontisto:telegram" />
  }, {
    name: "Twitter",
    href: twitter,
    icon: (props: SocialIconProps) => <Icon {...props} icon="fontisto:twitter" />
  }, {
    name: "GitHub",
    href: "https://github.com/chewyswap",
    icon: (props: SocialIconProps) => <Icon {...props} icon="fontisto:github" />
  }, {
    name: "Feedly",
    href: "https://feedly.com/i/subscription/feed%2Fhttps%3A%2F%2Fapp.chewyswap.dog%2Fapi%2Ffeed%2F",
    icon: (props: SocialIconProps) => <Icon {...props} icon="simple-icons:feedly" />
  }]
};
export default function Footer() {
  const $ = _c(12);
  const renderList = _temp2;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-center md:justify-start"><ChewyLogoFull className="w-1/2 md:w-[200px]" /></div>;
    t1 = <p className="text-small text-default-500">The ultimate Staking and Launchpad platform for NFT's and DeFi projects on Shibarium and Dogechain.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex space-x-6 justify-center md:justify-start">{footerNavigation.social.map(_temp3)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-8 md:pr-8">{t0}{t1}{t2}<div className="flex space-x-6 justify-center md:justify-start"><Link href={footerNavigation.aboutUs[1].href} isExternal={true}><Image src="https://chewyswap.dog/images/kyc.png" width="150px" radius="none" /></Link></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>{renderList({
        title: "Services",
        items: footerNavigation.services
      })}</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="md:grid md:grid-cols-2 md:gap-8">{t4}<div className="mt-10 md:mt-0">{renderList({
          title: "Help!",
          items: footerNavigation.supportOptions
        })}</div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div>{renderList({
        title: "About Us",
        items: footerNavigation.aboutUs
      })}</div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="xl:grid xl:grid-cols-3 xl:gap-8">{t3}<div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">{t5}<div className="md:grid md:grid-cols-2 md:gap-8">{t6}<div className="mt-10 md:mt-0">{renderList({
              title: "Partners & Links",
              items: footerNavigation.partners
            })}</div></div></div></div>;
    t8 = <Divider className="mt-16 sm:mt-20 lg:mt-24" />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="text-small text-default-400">© {new Date().getFullYear()} {pageTitle}. All Rights Reserved</p>;
    t10 = <link rel="alternate" type="application/rss+xml" title="RSS Feed for ChewySwap News" href="/api/feed/" />;
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <footer className="flex w-full flex-col boxWrap2Footer"><div className="max-w-7xl px-6 pb-2 pt-10 sm:pt-0 lg:px-8 lg:pt-10 self-center">{t7}{t8}<div className="flex flex-wrap justify-between gap-2 pt-8">{t9}{t10}<div><Link rel="alternate" type="application/rss+xml" title="RSS Feed for ChewySwap News" href="/api/feed/"><RssIcon width={20} color="orange" /></Link> </div></div></div></footer>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}
function _temp3(item_0) {
  return <Link key={item_0.name} isExternal={true} className="text-default-400" href={item_0.href}><span className="sr-only">{item_0.name}</span><item_0.icon aria-hidden="true" className="w-6" /></Link>;
}
function _temp2(t0) {
  const {
    title,
    items
  } = t0;
  return <div><h3 className="text-small font-semibold text-default-600">{title}</h3><ul className="mt-6 space-y-4">{items.map(_temp)}</ul></div>;
}
function _temp(item) {
  return <li key={item.name}><Link className="text-default-400" href={item.href} size="sm">{item.name}</Link></li>;
}